export const envs = {
	appType: import.meta.env.VITE_APP_TYPE,
	umsBaseUrl: import.meta.env.VITE_UMS_API_URL,
	hmsBaseUrl: import.meta.env.VITE_HMS_API_URL
};
